const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Editor from './edit';
import Save from './save';

registerBlockType('base/image-sumicity', {
  title: 'Imagem - Sumicity',
  description: 'Bloco de imagem com opções de posicionamento',
  icon: 'align-center',
  category: 'design',
  attributes,

  edit: (props) => <Editor {...props} />,
  save: (props) => <Save {...props} />,
});
